import { createStore } from "vuex"

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import moduleAuth from "./auth/moduleAuth.js"
import moduleApi from "./api/moduleApi.js"
import projects from "./projects"
import jobs from "./jobs"
import profileForm from "./profileForm"
import jobForm from "./jobForm"
import messaging from "./messaging"

export default createStore({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    api: moduleApi,
    projects,
    jobs,
    profileForm,
    jobForm,
    messaging,
  },
  strict: process.env.NODE_ENV !== "production",
})
